// eslint-disable-next-line @typescript-eslint/ban-types
const throttleFn = <
  P1 extends Array<any>,
  R1,
  P2 extends Array<any> = [],
  R2 = void,
>(func: (...params: P1) => R1, delay, onThrottle?: (...params: P2) => R2) => {
  let prev = 0;
  return (...args: any) => {
    const now = new Date().getTime();
    if (now - prev > delay) {
      prev = now;
      return func(...args as P1);
    }
    return onThrottle(...args as P2);
  };
};

export default throttleFn;
